import * as React from "react";
const SvgDebit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#6366F1"
      d="M16.667 2.667H7.333A1.333 1.333 0 0 0 6 4v16a1.333 1.333 0 0 0 1.333 1.333h9.334A1.333 1.333 0 0 0 18 20V4a1.334 1.334 0 0 0-1.333-1.333Zm-4 17.333h-1.334v-1.334h1.334V20Zm-5.334-2.667V4h9.334v13.333H7.333Z"
    />
    <path
      fill="#6366F1"
      d="M3.263 13.313a.431.431 0 0 0 .431.43h11.212a.431.431 0 0 0 .432-.43v-5.23H3.263v5.23Zm1.779-3.72a.216.216 0 0 1 .215-.216h2.48a.216.216 0 0 1 .216.216v1.725a.215.215 0 0 1-.216.216h-2.48a.215.215 0 0 1-.215-.216V9.593Zm9.864-5.337H3.694a.431.431 0 0 0-.431.432v1.779h12.075v-1.78a.431.431 0 0 0-.432-.43Z"
    />
  </svg>
);
export default SvgDebit;